"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const icons_1 = require("../../../assets/icons");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const scale_1 = require("../../../utils/scale");
const CollapseHeader = ({ title, collapsed, onToggle }) => {
    return (react_1.default.createElement(react_native_1.Pressable
    // style={styles.collapseHeader}
    , { 
        // style={styles.collapseHeader}
        style: ({ pressed }) => [
            styles.collapseHeader,
            (pressed) && styles.focusBg,
        ], onPress: onToggle },
        react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles.title }, title),
        react_1.default.createElement(react_native_1.View, { style: collapsed ? styles.arrowDown : styles.arrowUp },
            react_1.default.createElement(icons_1.IC_ARROW_RIGHT, { width: (0, scale_1.scale)(14), height: (0, scale_1.scale)(14), color: "#36363e" }))));
};
const CollapseContentItem = ({ title, ...props }) => {
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_native_1.Pressable, { ...props, style: ({ pressed }) => [styles.contentView, (pressed || isHovered) && styles.focusBg], onHoverIn: () => setIsHovered(true), onHoverOut: () => setIsHovered(false) },
        react_1.default.createElement(CustomText_1.default, { style: styles.content }, title)));
};
const PolicyItem = (props) => {
    const { data, index } = props;
    const [collapsed, setCollapsed] = (0, react_1.useState)(true);
    const [height, setHeight] = (0, react_1.useState)(0);
    const animation = (0, react_1.useRef)(new react_native_1.Animated.Value(0)).current;
    const toggleCollapse = () => {
        const toValue = collapsed ? 1 : 0;
        react_native_1.Animated.timing(animation, {
            toValue,
            duration: 200,
            useNativeDriver: false,
        }).start(() => {
            setCollapsed(!collapsed);
        });
    };
    const onLayout = (event) => {
        const onLayoutHeight = event.nativeEvent.layout.height;
        if (onLayoutHeight > 0 && height !== onLayoutHeight) {
            setHeight(onLayoutHeight);
        }
    };
    const containerStyle = {
        height: animation.interpolate({
            inputRange: [0, 1],
            outputRange: [0, height],
        }),
    };
    return (react_1.default.createElement(react_native_1.View, { style: styles.collapseItem },
        react_1.default.createElement(CollapseHeader, { title: data.title, collapsed: collapsed, onToggle: toggleCollapse }),
        react_1.default.createElement(react_native_1.Animated.View, { style: [{ overflow: 'hidden' }, containerStyle] },
            react_1.default.createElement(react_native_1.View, { onLayout: onLayout, style: { position: 'absolute', width: '100%' } }, data.items.map((it, idx) => (react_1.default.createElement(CollapseContentItem, { key: idx, title: it.title, onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.POLICY_DETAIL_SCREEN, {
                    index,
                    itemIndex: idx,
                }) })))))));
};
exports.default = PolicyItem;
const styles = react_native_1.StyleSheet.create({
    collapseItem: {
        width: '100%',
    },
    collapseHeader: {
        width: '100%',
        paddingVertical: (0, scale_1.scale)(12),
        paddingHorizontal: (0, scale_1.scale)(16),
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#EDEDED',
        borderBottomWidth: (0, scale_1.scale)(1),
        borderColor: '#DDDDDD',
    },
    title: {
        flex: 1,
        marginRight: (0, scale_1.scale)(24),
        fontSize: (0, scale_1.moderateScale)(12),
        lineHeight: (0, scale_1.moderateScale)(18),
        color: '#292A33',
    },
    arrowUp: {
        transform: [{ rotate: '-90deg' }],
    },
    arrowDown: {
        transform: [{ rotate: '90deg' }],
    },
    contentView: {
        paddingVertical: (0, scale_1.scale)(12),
        paddingHorizontal: (0, scale_1.scale)(16),
        borderBottomWidth: (0, scale_1.scale)(1),
        borderColor: '#DDDDDD',
    },
    content: {
        fontSize: (0, scale_1.moderateScale)(15),
        lineHeight: (0, scale_1.moderateScale)(22.5),
        color: '#292A33',
    },
    focusBg: {
        backgroundColor: '#DDD',
        ...react_native_1.Platform.select({
            web: {
                transitionProperty: 'all',
                transitionDuration: '200ms',
                transitionTimingFunction: 'ease',
            },
        }),
    },
});
